export default __webpack_public_path__ + "img/344ae5bb92e03373c0bebb8e5ea1a864.png";